import useAuth from "../../../hooks/useAuth";
import SimpleHeader from '../../../components/layout/SimpleHeader';
import { useTranslation } from "react-i18next";
import { Select, Table, TableColumnsType } from "antd";
import { useEffect, useState } from "react";
import Button from '../../../components/Button';
import Checkbox from '../../../components/Checkbox';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { doGetCodes } from '../../../store/treeCode.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { useSnackbar } from "notistack";
import { useHistory, useLocation } from "react-router-dom";
import { errorVariant, warningVariant } from '../../../lib/barVariant';
import { ITreeCode } from "../../../models/treeCodes.model";
import qs from 'qs';

const SystemTreeCode = () => {

    const { writeAuthYn } = useAuth();
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const { treeCodes, isLoading } = useSelector((state: RootState) => state.treeCode);
    const [field, setField] = useState<any>();
    const [keyword, setKeyword] = useState('');
    const [isInUse, setIsInUse] = useState(false);
    const { Option } = Select;
    const history = useHistory();
    const location = useLocation();
    let query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const { enqueueSnackbar } = useSnackbar();

    const [codeCount, setCodeCount] = useState(0);
    const [treeCodeData, setTreeCodeData] = useState<ITreeCode[]>([]);

    const fieldList = [
        { label: t('system.code.column2'), value: 'korName' },
        { label: t('system.code.column3'), value: 'engName' }
    ];

    useEffect(() => {
        if (i18n.language === 'ko') {
          setField('korName');
        } else {
          setField('engName');
        }
    
        getCodes();
    }, []);

    const getCodes = async () => {
        const res = await dispatch(doGetCodes());
    
        switch (res?.status) {
          case 200:
            break;
          case 401:
            dispatch(doRemoveAuth());
            break;
          case 403:
            enqueueSnackbar(t('common.message.forbidden'), warningVariant);
            history.push('/');
            break;
          case 404:
            enqueueSnackbar(t('common.message.notFound'), warningVariant);
            break;
          default:
            enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
        }
    };

    useEffect(() => {
        // query to state
        if (query.field) {
            setField(String(query.field));
        }
        if (query.keyword) {
            setKeyword(String(query.keyword));
        }
        if (query.isInUse) {
            setIsInUse(query.isInUse === 'true');
        }

        // data filtering
        if (treeCodes) {
            let data: ITreeCode[] = treeCodes;

            if (query.field && query.keyword) {
                data = data.filter(code => code[String(query.field)]?.toLowerCase()?.includes(String(query.keyword).toLowerCase()));
            }
            if (query.isInUse) {
                data = data.filter(code => code['useYn'] === 'Y');
            }

            setCodeCount(data.length);
            setTreeCodeData(data);
        }
    }, [location, treeCodes]);

    const onSearch = () => {
        const param: any = {};

        if (field && keyword) {
            param.field = field;
            param.keyword = keyword;
        }
        if (isInUse) {
            param.isInUse = true;
        }

        history.push(`/system/treecode?${qs.stringify(param)}`);
    }

    const columns: TableColumnsType<ITreeCode> = [
        {
          title: t('system.code.column1'),
          dataIndex: 'commonCode',
          key: 'commonCode',
          sorter: (a, b) => a.commonCode?.localeCompare(b.commonCode)
        },
        {
          title: t('system.code.column2'),
          dataIndex: 'korName',
          key: 'korName',
          sorter: (a, b) => a.korName?.localeCompare(b.korName)
        },
        {
          title: t('system.code.column3'),
          dataIndex: 'engName',
          key: 'engName',
          sorter: (a, b) => a.engName?.localeCompare(b.engName)
        },
        {
          title: t('system.code.column4'),
          dataIndex: 'useYn',
          key: 'useYn',
          sorter: (a, b) => a.useYn?.localeCompare(b.useYn)
        },
        {
          title: '',
          key: 'commonCode',
          dataIndex: 'commonCode',
          render: (value, record) => (
            <div className='comm-btn__area justify-content-center'>
              <Button
                className='btn-basic small pink-line'
                onClick={() => history.push(`/system/treecode/${record.commonCode}/edit${location.search}`)}
                text={t('common.button.edit')}
                writeAuthYn={writeAuthYn}
              />
              <Button
                className='btn-basic mint'
                onClick={() => {
                  const param = {
                    ko: record.korName,
                    en: record.engName
                  };
                  history.push(`/system/treecode/${record.commonCode}/subcode${location.search ? `${location.search}&` : '?'}${qs.stringify(param)}`);
                }}
                text={t('system.code.button1')}
              />
            </div>
          ),
        }
      ];

    return (
        <>
            <SimpleHeader
                iconFile="icon-system-big.svg"
                parentMenu={t('common.menu.system')}
                currentMenu={'트리코드 관리'}
                onlyTitle={true}
            />
            <div className="common-search">
                <div className="search-area">
                    <ul className="search-bx">
                        <li>
                            <label>{t('system.code.column5')}</label>
                            <div>
                                <Select
                                    value={field}
                                    onChange={value => setField(value)}
                                >
                                {
                                fieldList?.map((item: any) => {
                                    return (
                                    <Option
                                        key={item.value}
                                        value={item.value}
                                    >
                                        {item.label}
                                    </Option>
                                    )
                                })
                                }
                                </Select>
                            </div>
                            <input
                            type="text"
                            className="form-control w-240p"
                            value={keyword}
                            onChange={(e => setKeyword(e.target.value))}
                            onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
                            />
                            <div className="comm-btn__area">
                            <Button
                                className='btn-basic small black'
                                onClick={onSearch}
                                text={t('common.button.search')}
                            />
                            </div>
                        </li>
                        <li>
                            <label>{t('system.code.column4')}</label>
                            <div className="text-left">
                            <Checkbox
                                checked={isInUse}
                                onChange={setIsInUse}
                                text={t('common.text.inUse')}
                            />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="content scrollbar">

                <div className="col-frame">
                    <div className="comm-bx__between">
                        <div className="comm-sch_result">
                            {t('common.text.count')}: <b>0</b>{t('common.text.unit')}
                        </div>
                        <div className="comm-btn__area">
                            <Button
                            className='btn-basic pink'
                            onClick={() => history.push(`/system/treecode/create${location.search}`)}
                            text={t('common.button.create')}
                            writeAuthYn={writeAuthYn}
                            />
                        </div>
                    </div>
                    <div className='comm-table__area'>
                        <Table
                            columns={columns}
                            dataSource={treeCodeData}
                            pagination={{
                            pageSize: 99999
                            }}
                            rowKey={(record)=>record.commonCode}
                        />
                    </div>
                    <div className="comm-bx__space">
                        <div className="comm-btn__area right">
                            <Button
                            className='btn-basic pink'
                            onClick={() => history.push(`/system/treecode/create${location.search}`)}
                            text={t('common.button.create')}
                            writeAuthYn={writeAuthYn}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SystemTreeCode;